import request from '@/utils/request';
//获取车辆相关配置
export function getConfig(data = {}) {
    return request({
        url: '/api/common/getConfig',
        type: 'get',
        data
    })
}